import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { WidgetSettingsDto } from '@/Domain/api/WIdget/dto/WidgetSetting.dto';
import { UnifiedAiInsightsPage } from '@/UI/Insights/UnifiedAiInsights/UnifiedAiInsightsPage';

export const UnifiedAiInsightsLoader = () => {
  const { isLoading } = useQuery<WidgetSettingsDto>({
    queryKey: [QueryKey.widgetSettings],
  });

  if (isLoading) return null;

  return <UnifiedAiInsightsPage />;
};
